module.exports = __webpack_public_path__ + "img/csv.a49eeac0.png";